import HttpRequest from '@/config/axios.config'

export async function getInspectionTemplateRef(payload) {
  return await HttpRequest.get('/templates?type=1', { params: { ...payload } })
}

export async function getOrderTemplateRef(payload) {
  return await HttpRequest.get('/templates?type=2', { params: { ...payload } })
}

export async function getTimeActionTemplateRef(payload) {
  return await HttpRequest.get('/templates?type=4', { params: { ...payload } })
}

export async function getSingleTemplateRef(id: string) {
  return await HttpRequest.get(`/templates/${id}`)
}

export async function updateTemplateRef(payload: any) {
  return await HttpRequest.patch(`/templates/inspection/${payload.id}`, payload)
}

export async function deleteTemplateRef(id: string) {
  return await HttpRequest.patch(`/templates/inspection/${id}`, {
    status: 'inactive',
  })
}

export async function saveTemplateRef(payload: any) {
  return await HttpRequest.post(`/templates/inspection`, payload)
}
